import { Avatar, Box, Card, Collapse, Divider, Grid, IconButton, Skeleton, Typography, useTheme } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useEffect, useContext, useState } from 'react';
import {connect} from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ButtonBasic, CardUploadFile, ComentarioTicketCard, InputDropZoneComment, InputEditQuill, InputReadQuill, ListContratoSoft, ListInfoCam, ListTarea, TextEstadoTicket, TextEstadogTicketID, TextInfoTicket } from '../../components';
import { SocketContext } from '../../context/SocketContext';
import AuxiliarFunction from '../../function/AuxiliarFunction';
import FechaFunction from '../../function/FechaFunction';
import usePermisos from '../../hooks/usePermisos';
import ApiSoftland from '../../services/apis.softland.service'
import CalendarioV2Service from '../../services/calendarioV2.service';
import ComentarioTicketService from '../../services/comentarioTicket.service';
import TicketService from '../../services/tickets.service'
import { showModal } from 'react-redux-modal-provider';
import ModalSendEmailComentario from '../../modals/plantillas/ModalSendEmailComentario';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EditIcon from '@mui/icons-material/Edit';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import Compressor from 'compressorjs';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ModalCierreTicketNubicom from '../../modals/cierreTicket/ModalCierreTicketNubicom';
import ModalTicketIdLogs from '../../modals/ticket/ModalTicketIdLogs';
import ModalAsignarTicket from '../../modals/ticket/ModalAsignarTicket';
import ModalCrearTarea from '../../modals/tarea/ModalCrearTarea';
import ModalConfirmInstalacion from '../../modals/ticket/ModalConfirmInstalacion';
import ModalEditTicketNubicom from '../../modals/ticket/ModalEditTicketNubicom';
import ModalReaperturaTicket from '../../modals/ticket/ModalReaperturaTicket';
import TratoService from '../../services/tratos.service';
import TourIcon from '@mui/icons-material/Tour';
import ModalTicketNodoPanel from '../../modals/mikrotikV2/ModalTicketNodoPanel';
import MikrotikV2Service from '../../services/mikrotikV2.service';
import ModalTicketDetalleAdicional from '../../modals/ticket/ModalTicketDetalleAdicional';
import ModalCancelarCambioTitular from '../../modals/contacto/ModalCancelarCambioTitular';
import ModalAdjContratoConstancia from '../../modals/ticket/ModalAdjContratoConstancia';
import ModalConfirmarPrefactibilidad from '../../modals/tratos/ModalConfirmarPrefactibilidad';
import ModalConfirmarItemsPrefa from '../../modals/tratos/ModalConfirmarItemsPrefa';
import ModalEquipamientoServicio from '../../modals/tratos/ModalEquipamientoServicio';
import EquipamientoTkService from '../../services/equipamiento-ticket.service';
import ModalContadorVisitasServicio from '../../modals/tratos/ModalContadorVisitasServicio';
import AttachedFileCard from '../../components/card/AttachedFileCard';
import ZTaskService from '../../services/ztask.service';

const TicketGetByIdNubiScreen = ({
  user
}) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const {id} = useParams();
  const [trato, setTrato] = useState();
  const [tareas, setTareas] = useState(null);
  const [contratoSoft, setContratoSoft] = useState(null);
  const [linkContratoSoft, setLinkContratoSoft] = useState(null);
  const [ticket, setTicket] = useState();
  const [equipamientos, setEquipamientos] = useState([]);
  const [otServicio, setOtServicio] = useState(null);
  const [openTareas, setOpenTareas] = useState(true);
  const [openOT, setOpenOT] = useState(true);
  const [openOTCards, setOpenOTCards] = useState({});
  const [comentario, setComentario] = useState('');
  const permisos = usePermisos();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPage, setIsLoadingPage] = useState(false);
  const [isLoadingCliente, setIsLoadingCliente] = useState(true);
  const [tareasCerradas, setTareasCerradas] = useState(false);
  const [nuevoTitular, setNuevoTitular] = useState(null);
  const [files, setFiles] = useState([]);
  const [filesCompress, setFilesCompress] = useState([]);
  const navigate = useNavigate();
  const { sockets } = useContext( SocketContext );
  const token = localStorage.getItem('token');
  const extensionPermitida = ['png','jpg','jpeg','svg','x-png','wmv','mp4','avi','mov','plain','txt','doc','docx','pdf','xls','xlsx','lpp','kmz','kml'];
  const acceptInputFile = ''
  const urlNubi = 'https://zeta.strongsystems.com.ar:8000/api/img?url=tickets/'
  const actualizar = async() =>{
    setIsLoadingPage(true)
    await TicketService.getById(id,{type: 'nubicom'}).then(async(resp)=>{
        setTicket(resp);
        setIsLoadingPage(false);
        obtenerEquipamientos();
        if(resp.tratos.length > 0){
            setTrato(resp.tratos[0]);
        }
        if(resp?.tratrosSoft?.length > 0){
            await ApiSoftland.getContratos(resp?.tratrosSoft).then((re)=>{
              setContratoSoft(re)
            })
        }
    })
    .catch((er)=>{
        setIsLoadingPage(false);
        navigate('/tickets');
    })
  }
  const traerTareas = async() =>{
    await CalendarioV2Service.tareasTicketCalendar(id).then((tar)=>{
      const permitirTarea = [4,5,6]
      if(tar?.length > 0){
          if(permitirTarea.includes(tar[0].estadoTareaId_t)){
            setTareasCerradas(true)
          }else{
            setTareasCerradas(false)
          }
      }else{
        setTareasCerradas(true)
      }
      setTareas(tar)
    })
  }
  const obtenerEquipamientos = async() =>{
    await EquipamientoTkService.getAll({ticketId: id}).then((tar)=>{
      setEquipamientos(tar)
    })
  }

  const onSubmit = () =>{
    const form={
        ticketId_com : id,
        cuerpo_com: comentario,
        propertys: 'nubicom'
    }
    if(comentario && comentario.length > 16){
        setIsLoading(true);
        if(filesCompress?.length > 0){
          form.filesCompress = filesCompress;
        }
        if(permisos['comentarioNubi.register']){
            form.isVisible_com= false;
            ComentarioTicketService.register(form).then(()=>{
                sockets?.emit( 'ticketNubiRefresh', `ticket-nubi-${id}` );
                setFiles([])
                setFilesCompress([])
                setComentario('')
            })
            .finally(() => {
                setIsLoading(false);
            });
        }
    }else{
        toast.error('El comentario debe tener al menos 10 caractares.', {
            position: "top-right",
            autoClose: 2500,
            closeOnClick: true,
            pauseOnHover: false,
        });
    }
  }
  const onOpenSendEmail = () =>{
    showModal(ModalSendEmailComentario,{
      onGuardar: actualizar,
      ticketId: id,
      email: linkContratoSoft?.email || trato?.contactoEmail_t,
      nombreCliente: linkContratoSoft?.nombre || trato?.nombre_t
    })
  }
  const cierreTicketOK = () =>{
    sockets?.emit( 'ticketNubiRefresh', `ticket-nubi-${id}` );
    setIsLoadingPage(true);
  }
  const cerrarTicket = () =>{
    showModal(ModalCierreTicketNubicom, { ticket: ticket, confirm: cierreTicketOK, setIsLoadingPage: setIsLoadingPage, trato: trato });
  }

  useEffect(() => {
    const room = `ticket-nubi-${id}`;
    localStorage.setItem('ticketId', room);
    sockets?.emit('joinTicketRoom', room);
    setContratoSoft(null)
    setEquipamientos([]);
    setLinkContratoSoft(null)
    setTrato(null)
    setIsLoadingCliente(true)
    actualizar();
    document.title = `Ticket #${id}`;

    const onTicketRefresh = () => {
      setContratoSoft(null)
      setTrato(null)
      setLinkContratoSoft(null)
      setIsLoadingCliente(true)
      actualizar();
      if(permisos['calendar.getTareas']){
        setTimeout(() => {
          traerTareas();
        }, 300);
      }
    };
    sockets?.on('ticketNubiRefresh', onTicketRefresh);

    return () => {
      sockets?.off('ticketNubiRefresh', onTicketRefresh);
      sockets?.emit('leaveTicketRoom', room);
    };
  }, [id])

  useEffect(() => {
    if(permisos['calendar.getTareas']){
      setTimeout(() => {
        traerTareas();
      }, 300);
    }
  }, [permisos,id,ticket]);

  useEffect(() => {
    if(id && ticket){
      ZTaskService.getOTServicio({ ticketId: id, all: true }).then((resp) => {
        setOtServicio(resp?.data || resp);
      }).catch(() => {
        setOtServicio(null);
      });
    }
  }, [id, ticket]);
  const actualizarNodoPanelTicket = async(servicioId) =>{
    await MikrotikV2Service.actualizarTicketEquipoServicioId({ticketId: id,servicioId: servicioId}).then((resp)=>{
      if(resp?.id_tk){
        actualizar();
      }
    })
  }
  useEffect(() => {
      if(Array.isArray(contratoSoft) && contratoSoft?.length > 0){
          const dataAux = AuxiliarFunction.extraerDataContratoSonft(contratoSoft)
          setTimeout(() => {
            if( (!ticket?.nodoName_tk && !ticket?.tecServicio_tk) && dataAux?.servicioId){
              actualizarNodoPanelTicket(dataAux?.servicioId)
            }
          }, 500);
          setLinkContratoSoft(dataAux)
          setIsLoadingCliente(false)
      }else{
        setLinkContratoSoft(null)
        if(trato){
          setIsLoadingCliente(false)
        }
      }
  }, [contratoSoft, trato])
  const onDeletedFile = (fileDele) =>{
    const filesRest = files.filter((filI)=> filI.id !== fileDele?.id)
    const filesCompRest = filesCompress.filter((filI)=> filI.id !== fileDele?.id)
    setFiles(filesRest)
    setFilesCompress(filesCompRest)
  }
  const onCompressImg = async(imgx,ot) =>{
    if (!imgx || !imgx.name) {
      return;
    }
    if (!(imgx instanceof File) && !(imgx instanceof Blob)) {
      return;
    }
    if (!imgx.size || imgx.size === 0) {
      return;
    }
    const nombreCortado = imgx?.name?.split('.');
    let extension = nombreCortado[ nombreCortado?.length - 1 ];
    extension = extension?.toLowerCase();
    if(extensionPermitida.includes( extension ) ){
        setIsLoading(true);
        try {
          const img = new Compressor(imgx, {
              quality: 0.3,
              convertSize:2000000,
              success(result) {
                  result.id=imgx?.id
                  result.preview=imgx?.preview
                  setIsLoading(false);
                  setFilesCompress(old => [...old,result]);
              },
              error(err) {
                  console.error('Error al comprimir:', err);
                  setIsLoading(false);
                  // Si falla la compresión, agregar el archivo original
                  imgx.id = imgx?.id || Date.now();
                  imgx.preview = imgx?.preview || URL.createObjectURL(imgx);
                  setFilesCompress(old => [...old,imgx]);
              }
          })
        } catch (error) {
          console.error('Error en Compressor:', error);
          setIsLoading(false);
          // Si hay un error, agregar el archivo sin comprimir
          imgx.id = imgx?.id || Date.now();
          imgx.preview = imgx?.preview || URL.createObjectURL(imgx);
          setFilesCompress(old => [...old,imgx]);
        }
    }else{
      setFilesCompress(old => [...old,imgx]);
    }
  }

  const handlePasteFromClipboard = async () => {
    try {
      const clipboardItems = await navigator.clipboard.read();
      const extenPermitidas = ['png','jpg','jpeg'];
      let itemFound = false;
      for (const clipboardItem of clipboardItems) {
        for (const type of clipboardItem.types) {
          if (type.startsWith('image/')) {
            const blob = await clipboardItem.getType(type);
            if (!blob || blob.size === 0) {
              continue;
            }
            let extension = type.split('/')[1].toLowerCase();
            if (extension === 'x-png') {
              extension = 'png';
            } else if (extension === 'jpeg') {
              extension = 'jpg';
            }
            if (extenPermitidas.includes(extension)) {
              const timestamp = Date.now() + Math.floor(Math.random() * 1000);
              const fileName = `clipboard-image-${timestamp}.${extension}`;
              const mimeType = `image/${extension === 'jpg' ? 'jpeg' : extension}`;
              const file = new File([blob], fileName, { 
                type: mimeType,
                lastModified: Date.now()
              });
              if (file instanceof Blob && file.size > 0) {
                itemFound = true;
                setIsLoading(true);
                // Comprimir la imagen directamente aquí
                new Compressor(file, {
                  quality: 0.3,
                  convertSize: 2000000,
                  success(result) {
                    // Agregar propiedades necesarias
                    result.id = timestamp;
                    result.preview = URL.createObjectURL(result);
                    setFilesCompress(old => [...old, result]);
                    setIsLoading(false);
                    toast.success('Imagen pegada y comprimida correctamente', {
                      position: "top-right",
                      autoClose: 1500,
                    });
                  },
                  error(err) {
                    setIsLoading(false);
                    file.id = timestamp;
                    file.preview = URL.createObjectURL(file);
                    setFilesCompress(old => [...old, file]);
                  }
                });
              }
            }
          }
        }
      }
      if (!itemFound) {
        toast.info('No se encontró ninguna imagen en el portapapeles', {
          position: "top-right",
          autoClose: 2500,
        });
      }
    } catch (err) {
      console.error('Error al leer del portapapeles:', err);
      toast.error('No se pudo leer del portapapeles. Asegúrate de tener permisos y que haya una imagen copiada.', {
        position: "top-right",
        autoClose: 3000,
      });
    }
  }

  useEffect(() => {
    if(files.length > 0){
        files.forEach((filImg)=>{
            // Validar que el archivo sea válido antes de procesarlo
            if (!filImg || !filImg.name || !(filImg instanceof File || filImg instanceof Blob)) {
              console.warn('Archivo inválido detectado en useEffect, se omite:', filImg);
              return;
            }
            
            const existe = filesCompress.find((flCompress)=>flCompress.id === filImg.id)
            if(!existe){
                onCompressImg(filImg)
            }
        })
    }
  }, [files])

  const onOpenLogs = () =>{
    showModal(ModalTicketIdLogs, {
      ticketId: id,
      ticketIdOld: ticket.ticketIdOld_tk,
      type: 'nubicom',
      nombreCompleto: trato?.nombre_t || linkContratoSoft?.nombre,
      preServicioId: trato?.id_t,
      contactoId: trato?.contactoId_t,
      cuentaId: trato?.cuentaId_t || linkContratoSoft?.cuenta,
      servicioId: trato?.cuentaContratoId_t || linkContratoSoft?.servicioId,
    });
  }
  const onOpenAsignacion = () => {
    let socketOld = 2;
    if( ticket?.habilitadoTK?.tipo_uxt === 'DNI' && ticket?.habilitadoTK?.nombre_p){
        socketOld = ticket?.habilitadoTK?.dni_p
    }else if( ticket?.habilitadoTK?.tipo_uxt === 'GRUPO' && ticket?.habilitadoTK?.nombre_g){
        socketOld = ticket?.habilitadoTK?.id_g
    }
    showModal(ModalAsignarTicket, {
      ticketId: id,
      onGuardar:actualizar,
      type: 'nubicom',
      socketOld: socketOld,
      socketReturn:'ticketNubiRefresh',
      socketRoom: `ticket-nubi-${id}`,
      stageTicket: ticket?.stageTicket_tk
    });
  }
  const onGuardarActualizar = () =>{
    actualizar();
    traerTareas();
    obtenerEquipamientos();
  }
  const onOpenModalCrearTarea = () =>{
    showModal(ModalCrearTarea,{ticket: ticket, contratoSoft: contratoSoft, tareas:tareas, onGuardar:onGuardarActualizar })
  }
  const onOpenModalConfirmInstalacion = (tratoId) =>{
    showModal(ModalConfirmInstalacion, {ticketId: id, tratoId: tratoId, trato: trato, onGuardar: actualizar, nombreCliente: linkContratoSoft?.nombre || trato?.nombre_t});
  }
  const onOpenModalEditNubicom = ()=>{
    showModal(ModalEditTicketNubicom, {item: ticket, onGuardar: actualizar, trato: trato,linkContratoSoft: linkContratoSoft});
  }
  const onOpenReapertura = () =>{
    showModal(ModalReaperturaTicket,{onGuardar:actualizar,ticket: ticket, type: 'nubicom'})
  }
  const onOpenModalConfirmPrefactibilidad = (tratoId) =>{
    showModal(ModalConfirmarPrefactibilidad, {ticketId: id, tratoId: tratoId, onGuardar: actualizar});
  }
  const onOpenModalConfirmItemsPrefa = (tratoId) =>{
    showModal(ModalConfirmarItemsPrefa, {ticketId: id, tratoId: tratoId, onGuardar: actualizar});
  }
  const onClickNameCliente = () =>{
    if(linkContratoSoft?.cuenta){
      navigate(`/contactos/${linkContratoSoft?.cuenta}/cuenta`)
    }else if(trato?.cuentaId_t){
      navigate(`/contactos/${trato?.cuentaId_t}/cuenta`)
    }else{
      navigate(`/contactos/${trato?.contactoId_t}/nubicom`)
    }
  }
  const onClickNroServicio = () =>{
    if(linkContratoSoft?.servicioId){
      navigate(`/servicio/${linkContratoSoft?.servicioId}/cuenta`)
    }
  }
  const onClickCambioTitular = () =>{
    if(ticket?.ticketxtrato?.length > 0){
      const idTrato = ticket?.ticketxtrato[0]?.cuentaContratoId_txt
      if(contratoSoft?.length > 0 && contratoSoft[0][idTrato]?.length > 0){
        const tratoCuenta = contratoSoft[0][idTrato][0]
        navigate(`/contactos/cambio-titular`,{state:{trato: tratoCuenta,ticket: id}})
      }
    }
  }
  const consultarCambioTitularServicio = async(servicioId)=>{
    await TratoService.consultarCambioTitularServicio({servicioId:servicioId}).then((resp)=>{
      setNuevoTitular(resp)
    })
  }
  useEffect(() => {
    if(ticket && ticket?.motivo_tk === 26){
      if(ticket?.ticketxtrato?.length > 0){
        const idTrato = ticket?.ticketxtrato[0]?.cuentaContratoId_txt;
        if(contratoSoft?.length > 0 && contratoSoft[0][idTrato]?.length > 0){
          const tratoCuenta = contratoSoft[0][idTrato][0];
          consultarCambioTitularServicio(tratoCuenta?.numero);
        }
      }
    }
  }, [contratoSoft,ticket])
  const onCancelarCambioTitular = (idT) =>{
    showModal(ModalCancelarCambioTitular,{ ticketId: id, idPreServicio: idT, onGuardar: actualizar });
  }
  const onOpenModalNodoPanel = () =>{
    showModal(ModalTicketNodoPanel,{ticket: ticket, onGuardar: actualizar})
  }
  const onOpenModalDetAdd = () => {
    showModal(ModalTicketDetalleAdicional,{ticket: ticket, onGuardar: actualizar})
  }
  const onOpenModalEquipamientoAdd = () => {
    showModal(ModalEquipamientoServicio,{
      ticket: ticket?.id_tk,
      onGuardar: obtenerEquipamientos,
      servicioId: linkContratoSoft?.servicioId || trato?.id_t,
      itemsAll: equipamientos
    })
  }
  const onOpenModalAdjContConst = (idT) => {
    showModal(ModalAdjContratoConstancia,{ticket: ticket, idPreServicio: idT, onGuardar: actualizar})
  }
  const onOpenModalVisitasAdd = () => {
    showModal(ModalContadorVisitasServicio,{
      ticket: ticket?.id_tk,
      onGuardar: actualizar,
      servicioId: linkContratoSoft?.servicioId || trato?.id_t,
    })
  }
  return (
    <Box sx={{width:'100%',height: '100%',overflow:'auto', background: isDarkMode ? '#1a2332' : '#f5f5f5'}} className='side'>
      <Grid container sx={{marginBottom: 10,p:2,pl:4}}>
        <Grid item xs={12} mb={3}>
          <Card
            sx={{
              background: isDarkMode ? '#2d3a52' : '#fff !important',
              p: {xs: 1, sm: 1.5},
              display: 'flex',
              alignItems: 'center',
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
              border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0',
              boxShadow: isDarkMode 
                ? "0px 5px 0px -5px rgba(144,202,249,0.9),0px 2px 0px 0px rgba(144,202,249,0.5),0px 3px 0px 0px rgba(144,202,249,0.6)"
                : "0px 5px 0px -5px rgba(1,154,221,0.9),0px 2px 0px 0px rgba(1,154,221,0.5),0px 3px 0px 0px rgba(1,154,221,0.6)"
            }}
          >
            <Grid container spacing={1}>
              {/* Botón de regreso */}
              <Grid item xs={12} sm={1} md={1} display='flex' justifyContent={{xs: 'flex-start', sm: 'space-between'}} alignItems='center'>
                <IconButton 
                  sx={{
                    boxShadow: 3,
                    marginLeft: {xs: 0, sm: 2},
                    width: 35, 
                    height: 35,
                    background: isDarkMode ? '#1F2A40' : '#fff',
                    '&:hover': {background: isDarkMode ? '#3d4a62' : '#f5f5f5'}
                  }} 
                  onClick={()=>navigate(-1)}
                >
                  <ArrowBackIcon sx={{color: isDarkMode ? '#90caf9' : '#15294b', fontSize: 17}} />
                </IconButton>
              </Grid>

              {/* Logo y título del ticket */}
              <Grid item xs={12} sm={7} md={9} display='flex' justifyContent={{xs: 'flex-start', sm: 'start'}} alignItems='center'>
                <Box sx={{
                  boxShadow: 4, 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  borderRadius: 50,
                  width: 35, 
                  height: 35,
                  flexShrink: 0
                }}>
                  <Avatar alt="Logo Nubicom" src='/img/nubi-cirucular.png' sx={{ width: 34, height: 34, marginTop: 0.1 }} />
                </Box>
                <Box
                  title={ticket?.titulo_tk}
                  sx={{
                    fontWeight: 'normal',
                    color: isDarkMode ? '#e0e0e0' : '#15294b',
                    display: 'flex', 
                    flexDirection: {xs: 'column', sm: 'row'},
                    alignItems: {xs: 'flex-start', sm: 'center'},
                    ml: 1,
                    fontSize: 14,
                    overflow: 'hidden',
                    minWidth: 0,
                    width: '100%'
                  }}
                  component='div'
                >
                  <Box fontWeight='bold' display='inline' sx={{fontSize: 14, mr: {xs: 0, sm: 0.5}, flexShrink: 0}}>
                    {`TICKET #${ticket?.id_tk}${window.innerWidth >= 600 ? ' - ' : ''}`}
                  </Box>
                  <Box sx={{
                    overflow: {xs: 'visible', sm: 'hidden'},
                    textOverflow: {xs: 'clip', sm: 'ellipsis'},
                    whiteSpace: {xs: 'normal', sm: 'nowrap'},
                    flex: 1,
                    minWidth: 0,
                    wordBreak: {xs: 'break-word', sm: 'normal'}
                  }}>
                    {ticket?.titulo_tk}
                  </Box>
                </Box>
              </Grid>

              {/* Ver historial y Asignar ticket */}
              <Grid 
                item 
                xs={12} 
                sm={4} 
                md={2} 
                display='flex' 
                flexDirection={{xs: 'row', sm: 'row'}}
                justifyContent={{xs: 'space-between', sm: 'center'}} 
                alignItems='center'
                gap={1}
              >
                <Typography
                  sx={{
                    color: isDarkMode ? '#90caf9' : '#0364ff',
                    cursor: 'pointer',
                    fontSize: {xs: 14, sm: 15, md: 14},
                    '&:hover': {textDecoration: 'underline'}
                  }} 
                  variant='h6'
                  onClick={()=>onOpenLogs()}
                >
                  Ver historial
                </Typography>
                { ticket && (ticket.habilitadoTK && ticket.habilitadoTK.ticketId_uxt || permisos && permisos['asignacionGral.nubicom']) && !ticket.cerrado_tk && ticket?.fechavencimiento_tk &&(
                  <ButtonBasic
                    textButton='Asignar ticket'
                    variant='wk'
                    color='nextStep'
                    sx={{
                      ml: {xs: 0, sm: 0.5},
                      height: '75%',
                      fontSize: {xs: 11, sm: 12}
                    }}
                    onClick={()=>onOpenAsignacion()}
                  />
                )}
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={12} md={2.9}>
          <Card sx={{
            background: isDarkMode ? '#2d3a52' : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
            borderRadius: '12px',
            marginBottom: 5,
            boxShadow: isDarkMode ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.08)',
            border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e8ef',
            overflow: 'hidden',
            animation: 'slideInRight 0.5s ease-out',
            '@keyframes slideInRight': {
              '0%': {
                opacity: 0,
                transform: 'translateX(30px)'
              },
              '100%': {
                opacity: 1,
                transform: 'translateX(0)'
              }
            }
          }}>
            {/* Header Cliente con gradiente */}
            <Box sx={{
              background: isDarkMode ? 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)' : 'linear-gradient(135deg, #0364ff 0%, #4a90e2 100%)',
              py: 1.5,
              px: 2,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              boxShadow: isDarkMode ? '0 2px 8px rgba(37,99,235,0.3)' : '0 2px 8px rgba(3,100,255,0.2)'
            }}>
              <AccountCircleIcon sx={{color: isDarkMode ? '#e0e0e0' : '#fff', fontSize: 28}} />
              {isLoadingCliente ? (
                <Skeleton 
                  variant="text" 
                  width="60%" 
                  height={28}
                  sx={{bgcolor: 'rgba(255, 255, 255, 0.2)'}}
                />
              ) : (
                <Typography
                  sx={{
                    color: isDarkMode ? '#e0e0e0' : '#fff',
                    fontWeight: 700,
                    fontSize: 16,
                    letterSpacing: '0.3px',
                    cursor: 'pointer',
                    '&:hover': {textDecoration: 'underline'}
                  }}
                  variant='h5'
                  onClick={()=>onClickNameCliente()}
                >
                  {linkContratoSoft?.nombre || trato?.nombre_t}
                </Typography>
              )}
            </Box>

            {/* Nombre del cliente */}
            {isLoadingCliente ? (
              <Box sx={{display: 'flex', justifyContent: 'center', mt: 1, px: 2}}>
                <Skeleton variant="text" width="80%" height={20} />
              </Box>
            ) : (
              linkContratoSoft?.nombreServicio && (
                <Typography
                  sx={{textAlign: 'center',mt:1,color: isDarkMode ? '#90caf9' : '#0364ff',fontWeight: 'bold', fontSize: 13,cursor: 'pointer', '&:hover':{color: isDarkMode ? '#64B5F6' : '#0f98c5'}}}
                  variant='h5'
                  onClick={()=>onClickNroServicio()}
                >
                  {`${linkContratoSoft?.servicioId || ''} ${linkContratoSoft?.servicioId ? '-' : ''} ${linkContratoSoft?.nombreServicio}`}
                </Typography>
              )
            )}
            {isLoadingCliente ? (
              <Box sx={{px: 2, mt: 1}}>
                <Skeleton variant="text" width="100%" height={18} />
                <Skeleton variant="text" width="90%" height={18} sx={{mt: 0.3}} />
                <Skeleton variant="text" width="85%" height={18} sx={{mt: 0.3}} />
                <Skeleton variant="text" width="75%" height={18} sx={{mt: 0.3}} />
                <Skeleton variant="text" width="80%" height={18} sx={{mt: 0.3}} />
              </Box>
            ) : (
              <>
                {(linkContratoSoft?.vip || trato?.nivelVip_t) && (
                    <Typography
                      sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold', fontSize: 13,textAlign: 'center',mt: 0.3}}
                      component='div'
                    >
                      Nivel VIP:
                      <Box fontWeight='normal' display='inline' color={isDarkMode ? '#b0bec5' : '#15294b'}>
                        {linkContratoSoft?.vip || trato?.nivelVip_t}
                      </Box>
                    </Typography>
                )}
                {(linkContratoSoft?.domicilio || trato?.direccion_t) && (
                    <Typography
                      sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold', fontSize: 12,textAlign: 'center',mt: 1}}
                      component='div'
                    >
                      Dirección:
                      <Box fontWeight='normal' display='inline'>
                        {linkContratoSoft?.domicilio || trato?.direccion_t}
                      </Box>
                    </Typography>
                )}
                {(linkContratoSoft?.localidad || ticket?.localidadTk?.codLocalidad) && (
                    <Typography
                      sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold', fontSize: 12,textAlign: 'center',mt: 0.3}}
                      component='div'
                    >
                      Localidad:
                      <Box fontWeight='normal' display='inline'>
                        {linkContratoSoft?.localidad
                          ? linkContratoSoft?.localidad
                          : `${ticket?.localidadTk?.codLocalidad} - ${ticket?.localidadTk?.nombre || ''}`
                        }
                      </Box>
                    </Typography>
                )}
                {(linkContratoSoft?.localidadCalendario) && (
                    <Typography
                      sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold', fontSize: 10,textAlign: 'center',mt: 0.3}}
                      component='div'
                    >
                      Localidad Calendario:
                      <Box fontWeight='normal' display='inline'>
                        {linkContratoSoft?.localidadCalendario}
                      </Box>
                    </Typography>
                )}
                {(linkContratoSoft?.coordenadas || trato?.coordenadas_t) && (
                    <Typography
                      sx={{display: 'grid',color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold', fontSize: 12,textAlign: 'center',mt: 0.3}}
                      component='div'
                    >
                      Coordenadas:
                      <Box fontWeight='normal' display='inline' sx={{textAlign: 'center'}}>
                        {linkContratoSoft?.coordenadas
                          ? linkContratoSoft?.coordenadas
                          : trato?.coordenadas_t
                        }
                      </Box>
                    </Typography>
                )}
              </>
            )}
            {isLoadingCliente ? (
              <Box sx={{px: 2, mt: 0.3}}>
                <Skeleton variant="text" width="70%" height={18} />
                <Skeleton variant="text" width="65%" height={18} sx={{mt: 0.3}} />
              </Box>
            ) : (
              <>
                {(linkContratoSoft?.telefono || trato?.celular_t) && (
                  <Typography
                    sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold', fontSize: 12,textAlign: 'center',mt: 0.3}}
                    component='div'
                  >
                    Telefono:
                    <Box fontWeight='normal' display='inline'>
                      {linkContratoSoft?.telefono || trato?.celular_t}
                    </Box>
                  </Typography>
                )}
                {(linkContratoSoft?.telefono2) && (
                  <Typography
                    sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold', fontSize: 12,textAlign: 'center',mt: 0.3}}
                    component='div'
                  >
                    Telefono2:
                    <Box fontWeight='normal' display='inline'>
                      {linkContratoSoft?.telefono2}
                    </Box>
                  </Typography>
                )}
              </>
            )}
            {isLoadingCliente ? (
              <Box sx={{display: 'flex', justifyContent:'end', gap: 1, mr: 1, mt: 1}}>
                <Skeleton variant="rectangular" width={80} height={30} sx={{borderRadius: 1}} />
                <Skeleton variant="circular" width={30} height={30} />
              </Box>
            ) : (
              <Box sx={{display: 'flex', justifyContent:'end',mr: 1,mt: 1}}>
                {ticket && !ticket?.cerrado_tk && (
                  <ButtonBasic
                    textButton='Email'
                    variant='wk'
                    color='downloadHome'
                    sx={{background: isDarkMode ? '#2d3a52' : 'white',boxShadow: 3, color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold',fontSize:11}}
                    iconStart={<EmailOutlinedIcon sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontSize: '16px !important'}} />}
                    onClick={()=>onOpenSendEmail()}
                  />
                )}
              {((ticket && ticket?.cerrado_tk && permisos['ticket.editNubiCerrado']) || (ticket && !ticket?.cerrado_tk)) && (
                <IconButton
                  sx={{boxShadow: 3, display: 'flex', justifyContent: 'center', alignItems: 'center',width:30,height: 30,marginLeft:2, background: isDarkMode ? '#1F2A40' : '#fff', '&:hover': {background: isDarkMode ? '#3d4a62' : '#f5f5f5'}}}
                  onClick={()=>onOpenModalEditNubicom()}
                >
                  <EditIcon sx={{color: isDarkMode ? '#90caf9' : '#0364ff', fontSize: 18}} />
                </IconButton>
              )}
              </Box>
            )}
            <Divider sx={{
              background: isDarkMode ? 'linear-gradient(90deg, transparent, #3d4a62 50%, transparent)' : 'linear-gradient(90deg, transparent, #cbd5e0 50%, transparent)',
              height: '1px',
              border: 'none',
              my: 1
            }} />
            {/* Sección con diseño mejorado */}
            <Box>
              <Card sx={{
                background: isDarkMode ? '#2d3a52' : 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
                borderRadius: '0px',
                border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e8ef',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                }
              }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  px: 2,
                  py: 1.5,
                  background: isDarkMode ? '#2d3a52' : 'linear-gradient(135deg, #e3f2fd 0%, #f0f7ff 100%)',
                  borderBottom: isDarkMode ? '1px solid #3d4a62' : '1px solid #bbdefb'
                }}>
                  <Box sx={{
                    width: 4,
                    height: 18,
                    background: isDarkMode ? 'linear-gradient(180deg, #1e3a8a 0%, #2563eb 100%)' : 'linear-gradient(180deg, #0364ff 0%, #4a90e2 100%)',
                    borderRadius: '2px'
                  }} />
                  <Typography sx={{
                    color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                    fontWeight: 700,
                    fontSize: 14,
                    letterSpacing: '0.3px'
                  }} variant='h5'>
                    Datos del ticket
                  </Typography>
                </Box>
                <Box display='flex' flexDirection='column' sx={{p: 1.5}}>
              {ticket?.createdAt && (
                <TextInfoTicket
                  titulo='Fecha de creación'
                  descripcion={FechaFunction.format(new Date(ticket?.createdAt),'dd/MM/yyyy')}
                />
              )}
              {ticket && (ticket.estado_tk !== "CERRADO") ? (
                <TextEstadoTicket
                  titulo='Asignado a'
                  descripcion={ticket && ticket.habilitadoTK && (ticket.estado_tk !== "CERRADO") && ticket?.habilitadoTK.tipo_uxt === 'DNI'
                  ? ticket?.habilitadoTK?.nombre_p : ticket?.habilitadoTK?.nombre_g}
                />
              ):(
                <TextInfoTicket
                  titulo='Ultima Asignacion:'
                  descripcion={ticket && ticket.ultimaAsignacion && ticket?.ultimaAsignacion?.id_p
                  ? `${ticket?.ultimaAsignacion?.nombre_p} - ${ticket?.ultimaAsignacion?.departamento_p}`
                  : ticket?.ultimaAsignacion?.nombre_g }
                />
              )}
              {ticket && ticket?.estado_tk === 'CERRADO'&&(
                <TextInfoTicket
                  titulo='Fecha Cierre'
                  descripcion={ticket && ticket.fechavencimiento_tk && ticket.estado_tk === 'CERRADO' ? ( FechaFunction.format(new Date(ticket?.cerrado_tk),'dd/MM/yyyy HH:mm:ss') ):( 'Sin Definir')}
                />
              )}
              { ticket && ticket?.finalAsig_tk?.nombre_g &&(
                <TextInfoTicket
                  titulo='Revision final:'
                  descripcion={ticket?.finalAsig_tk?.nombre_g}
                />
              )}
              { ticket && ticket?.motivotk &&(
                <TextInfoTicket
                  titulo='Plantilla'
                  descripcion={ticket?.motivotk?.motivo_mt}
                />
              )}
                </Box>
              </Card>
            </Box>
            <Divider sx={{
              background: isDarkMode ? 'linear-gradient(90deg, transparent, #3d4a62 50%, transparent)' : 'linear-gradient(90deg, transparent, #cbd5e0 50%, transparent)',
              height: '1px',
              border: 'none',
              my: 1
            }} />
            <Box>
              <Card sx={{
                background: isDarkMode ? '#2d3a52' : 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
                borderRadius: '0px',
                border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e8ef',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                }
              }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  px: 2,
                  py: 1.5,
                  background: isDarkMode ? 'linear-gradient(135deg, #1a3a2a 0%, #2a4a3a 100%)' : 'linear-gradient(135deg, #e8f5e9 0%, #f1f8f4 100%)',
                  borderBottom: isDarkMode ? '1px solid #3d6250' : '1px solid #c8e6c9'
                }}>
                  <Box sx={{
                    width: 4,
                    height: 18,
                    background: isDarkMode ? 'linear-gradient(180deg, #2d5a3a 0%, #4a8c5a 100%)' : 'linear-gradient(180deg, #4caf50 0%, #81c784 100%)',
                    borderRadius: '2px'
                  }} />
                  <Typography sx={{
                    color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                    fontWeight: 700,
                    fontSize: 14,
                    letterSpacing: '0.3px'
                  }} variant='h5'>
                    Información del estado
                  </Typography>
                </Box>
                <Box display='flex' flexDirection='column' sx={{p: 1.5}}>
              <TextInfoTicket
                titulo='Prioridad'
                descripcion={ticket?.prioridad_tk}
              />
              <TextEstadoTicket
                titulo='Estado'
                descripcion={ticket?.estado_tk}
                abiertoCerrado
                estado={ticket?.cerrado_tk}
              />
              <TextInfoTicket
                titulo='Etapa del ticket'
                descripcion={ticket?.stageTicket_tk}
              />
                </Box>
              </Card>
            </Box>
            <Divider sx={{
              background: isDarkMode ? 'linear-gradient(90deg, transparent, #3d4a62 50%, transparent)' : 'linear-gradient(90deg, transparent, #cbd5e0 50%, transparent)',
              height: '1px',
              border: 'none',
              my: 1
            }} />
            <Box>
              <Card sx={{
                background: isDarkMode ? '#2d3a52' : 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
                borderRadius: '0px',
                border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e8ef',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                }
              }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  px: 2,
                  py: 1.5,
                  background: isDarkMode ? 'linear-gradient(135deg, #3a2e1a 0%, #4a3e2a 100%)' : 'linear-gradient(135deg, #fff3e0 0%, #fff8f0 100%)',
                  borderBottom: isDarkMode ? '1px solid #5a4a32' : '1px solid #ffe0b2'
                }}>
                  <Box sx={{
                    width: 4,
                    height: 18,
                    background: isDarkMode ? 'linear-gradient(180deg, #b45309 0%, #f59e0b 100%)' : 'linear-gradient(180deg, #ff9800 0%, #ffb74d 100%)',
                    borderRadius: '2px'
                  }} />
                  <Typography sx={{
                    color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                    fontWeight: 700,
                    fontSize: 14,
                    letterSpacing: '0.3px'
                  }} variant='h5'>
                    Gestión de tiempo
                  </Typography>
                </Box>
                <Box display='flex' flexDirection='column' sx={{p: 1.5}}>
              <TextInfoTicket
                titulo='Fecha de vencimiento'
                descripcion={ticket && ticket.fechavencimiento_tk ? ( FechaFunction.format(ticket?.fechavencimiento_tk,'dd/MM/yyyy') ):( 'Sin Definir')}
              />
              <TextEstadogTicketID
                titulo='Estado de vencimiento'
                descripcion={ticket?.estadoVencimiento_tk}
              />
              {ticket && ticket?.trancurrido && !ticket?.cerrado_tk && (
                <TextInfoTicket
                  titulo='Tiempo transcurrido'
                  descripcion={ticket?.trancurrido}
                />
              )}
              {ticket && !ticket?.trancurrido && ticket?.cerrado_tk && (
                <TextInfoTicket
                  titulo='Tiempo transcurrido'
                  descripcion={ticket?.timeElapsed_tk?.time}
                />
              )}
                </Box>
              </Card>
            </Box>
            <Divider sx={{
              background: isDarkMode ? 'linear-gradient(90deg, transparent, #3d4a62 50%, transparent)' : 'linear-gradient(90deg, transparent, #cbd5e0 50%, transparent)',
              height: '1px',
              border: 'none',
              my: 1
            }} />
            <Box>
              <Card sx={{
                background: isDarkMode ? '#2d3a52' : 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
                borderRadius: '0px',
                border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e8ef',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                }
              }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  px: 1,
                  py: 1,
                  background: isDarkMode ? 'linear-gradient(135deg, #3a2a4a 0%, #4a3a5a 100%)' : 'linear-gradient(135deg, #f3e5f5 0%, #f9f0fa 100%)',
                  borderBottom: isDarkMode ? '1px solid #5a4a6a' : '1px solid #e1bee7'
                }}>
                  <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                    <Box sx={{
                      width: 4,
                      height: 18,
                      background: isDarkMode ? 'linear-gradient(180deg, #7c3aed 0%, #a78bfa 100%)' : 'linear-gradient(180deg, #9c27b0 0%, #ba68c8 100%)',
                      borderRadius: '2px'
                    }} />
                    <Typography sx={{
                      color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                      fontWeight: 700,
                      fontSize: 14,
                      letterSpacing: '0.3px'
                    }} variant='h5'>
                      Detalle Adicional
                    </Typography>
                  </Box>
                  <IconButton
                    sx={{
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      width: 28,
                      height: 28,
                      background: isDarkMode ? 'linear-gradient(135deg, #2d3a52 0%, #3d4a62 100%)' : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        background: isDarkMode ? 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)' : 'linear-gradient(135deg, #0364ff 0%, #4a90e2 100%)',
                        transform: 'rotate(90deg)',
                        '& svg': {
                          color: isDarkMode ? '#e0e0e0' : '#fff'
                        }
                      }
                    }}
                    onClick={()=>onOpenModalDetAdd()}
                  >
                    <EditIcon sx={{color: isDarkMode ? '#e0e0e0' : '#2c3e50', fontSize: 14}} />
                  </IconButton>
                </Box>
                <Box display='flex' flexDirection='column' sx={{p: 1.5}}>
              { ticket && ticket?.codCanalNombre_tk &&(
                <TextInfoTicket
                  titulo='Canal'
                  descripcion={ticket?.codCanalNombre_tk}
                />
              )}
              { ticket && ticket?.tipoTicketId_tk &&(
                <TextInfoTicket
                  titulo='Tipo de ticket'
                  descripcion={ticket?.tipoTicket?.nombre_ttk}
                />
              )}
              { ticket && ticket?.subTipoTicketId_tk &&(
                <TextInfoTicket
                  titulo='Sub-Tipo de ticket'
                  descripcion={ticket?.subTipoTicket?.nombre_sttk}
                />
              )}
              { ticket && ticket?.submotivotk &&(
                <TextInfoTicket
                  titulo='Sub-Motivo'
                  descripcion={ticket?.submotivotk?.titulo_smt}
                />
              )}
              { ticket && ticket?.nivelAdmTkId_tk &&(
                <TextInfoTicket
                  titulo='Nivel Administrativo'
                  descripcion={ticket?.nivelAdmTicket?.nombre_natk}
                />
              )}
              { ticket && ticket?.motivoBajaTk_tk &&(
                <TextInfoTicket
                  titulo='Motivo Baja'
                  descripcion={ticket?.motivoBajaTk?.nombre_mbtk}
                />
              )}
              { ticket && ticket?.subMotivoBajaId_tk &&(
                <TextInfoTicket
                  titulo='SubMotivo Baja'
                  descripcion={ticket?.subMotivoBaja?.nombre_smb}
                />
              )}
              { ticket && ticket?.motivoBajaProveedorTk_tk &&(
                <TextInfoTicket
                  titulo='Proveedor'
                  descripcion={ticket?.motivoBajaProveedorTk_tk}
                />
              )}
              { ticket && ticket?.cierreTicket &&(
                <TextInfoTicket
                  titulo='Motivo de Cierre'
                  descripcion={ticket?.cierreTicket?.nombre_ct}
                />
              )}
              { ticket && ticket?.subCierreTicket &&(
                <TextInfoTicket
                  titulo='Sub-Motivo de Cierre'
                  descripcion={ticket?.subCierreTicket?.nombre_sct}
                />
              )}
                <TextInfoTicket
                  titulo='Seg. Detalle Adicional'
                  descripcion={ticket?.articuloFallaTk?.nombre_atk || '-'}
                />
                <TextInfoTicket
                  titulo='Problematica'
                  descripcion={ticket?.problematicaStr || '-'}
                />
                <TextInfoTicket
                  titulo='Solucion tecnica'
                  descripcion={ticket?.solucionTecStr || '-'}
                />
                <TextInfoTicket
                  titulo='Derivo en Asistencia'
                  descripcion={ticket?.derivoAsis_tk || '-'}
                />
                {(ticket?.motivo_tk === 40 || ticket?.motivo_tk === 36 || ticket?.motivo_tk === 7) &&(
                  <TextInfoTicket
                    titulo='Linea de Vista'
                    descripcion={ticket?.lineaVista_tk || '-'}
                  />
                )}
                <TextInfoTicket
                  titulo='Cant. Visitas'
                  descripcion={(
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                      <Typography sx={{marginTop: 0.2, marginRight: 1}}>
                        {ticket?.cantVisitas_tk || '0'}
                      </Typography>
                      <IconButton
                        sx={{boxShadow: 3, display: 'flex', justifyContent: 'center', alignItems: 'center',width:23,height: 23}}
                      >
                        <TourIcon sx={{color: isDarkMode ? '#90caf9' : '#0364ff',fontSize: 12}} />
                      </IconButton>
                    </Box>
                  )}
                  onClick={()=>onOpenModalVisitasAdd()}
                />
                </Box>
              </Card>
            </Box>
            {ticket?.tipoTicket?.nombre_ttk === 'TECNICO' && (
              <>
                <Divider sx={{
                  background: isDarkMode ? 'linear-gradient(90deg, transparent, #3d4a62 50%, transparent)' : 'linear-gradient(90deg, transparent, #cbd5e0 50%, transparent)',
                  height: '1px',
                  border: 'none',
                  my: 1
                }} />
                <Box>
                  <Card sx={{
                    background: isDarkMode ? '#2d3a52' : 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
                    borderRadius: '0px',
                    border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e8ef',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                    overflow: 'hidden',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                    }
                  }}>
                    <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      px: 2,
                      py: 1.5,
                      background: isDarkMode ? 'linear-gradient(135deg, #1a3a3a 0%, #2a4a4a 100%)' : 'linear-gradient(135deg, #e0f7fa 0%, #f0fafb 100%)',
                      borderBottom: isDarkMode ? '1px solid #3d5a5a' : '1px solid #b2ebf2'
                    }}>
                      <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                        <Box sx={{
                          width: 4,
                          height: 18,
                          background: isDarkMode ? 'linear-gradient(180deg, #0891b2 0%, #22d3ee 100%)' : 'linear-gradient(180deg, #00bcd4 0%, #4dd0e1 100%)',
                          borderRadius: '2px'
                        }} />
                        <Typography sx={{
                          color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                          fontWeight: 700,
                          fontSize: 14,
                          letterSpacing: '0.3px'
                        }} variant='h5'>
                          Nodo - Panel
                        </Typography>
                      </Box>
                      {!ticket?.cerrado_tk && (contratoSoft?.length >=2 || contratoSoft?.length === 0 || linkContratoSoft?.nombre === 'TICKET MAESTRO') && (
                        <IconButton
                          sx={{
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            width: 28,
                            height: 28,
                            background: isDarkMode ? 'linear-gradient(135deg, #2d3a52 0%, #3d4a62 100%)' : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                              background: isDarkMode ? 'linear-gradient(135deg, #0891b2 0%, #22d3ee 100%)' : 'linear-gradient(135deg, #0364ff 0%, #4a90e2 100%)',
                              transform: 'rotate(90deg)',
                              '& svg': {
                                color: isDarkMode ? '#e0e0e0' : '#fff'
                              }
                            }
                          }}
                          onClick={()=>onOpenModalNodoPanel()}
                        >
                          <EditIcon sx={{color: isDarkMode ? '#e0e0e0' : '#2c3e50', fontSize: 14}} />
                        </IconButton>
                      )}
                    </Box>
                    <Box display='flex' flexDirection='column' sx={{p: 1.5}}>
                  <TextInfoTicket
                    titulo='Tecnologia'
                    descripcion={ticket?.tecServicio_tk?.toUpperCase() || '-'}
                  />
                  <TextInfoTicket
                    titulo='Nodo'
                    descripcion={ticket?.nodoName_tk || '-'}
                  />
                  <TextInfoTicket
                    titulo={ticket?.tecServicio_tk === 'fibra' ? 'Nap' :'Panel'}
                    descripcion={ticket?.panelName_tk || '-'}
                  />
                  {ticket?.tecServicio_tk === 'fibra' && (
                    <TextInfoTicket
                      titulo='Puerto'
                      descripcion={ticket?.puertoNap_tk || '-'}
                    />
                  )}
                  {ticket?.tecServicio_tk === 'radio' && (
                    <TextInfoTicket
                      titulo='Tecnologia RF'
                      descripcion={ticket?.tipoEquipoRF_tk || '-'}
                    />
                  )}
                  <TextInfoTicket
                    titulo='Equipo'
                    descripcion={ticket?.equipoTec_tk || '-'}
                  />
                  <TextInfoTicket
                    titulo='Mac'
                    descripcion={ticket?.macEquipo_tk || '-'}
                  />
                    </Box>
                  </Card>
                </Box>
              </>
            )}
            <Divider sx={{
              background: isDarkMode ? 'linear-gradient(90deg, transparent, #3d4a62 50%, transparent)' : 'linear-gradient(90deg, transparent, #cbd5e0 50%, transparent)',
              height: '1px',
              border: 'none',
              my: 1
            }} />
            <Box>
              <Card sx={{
                background: isDarkMode ? '#2d3a52' : 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
                borderRadius: '0px',
                border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e8ef',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                }
              }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  px: 1.5,
                  py: 1,
                  background: isDarkMode ? 'linear-gradient(135deg, #3a1a1a 0%, #4a2a2a 100%)' : 'linear-gradient(135deg, #ffebee 0%, #fff5f5 100%)',
                  borderBottom: isDarkMode ? '1px solid #5a3a3a' : '1px solid #ffcdd2'
                }}>
                  <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                    <Box sx={{
                      width: 4,
                      height: 18,
                      background: isDarkMode ? 'linear-gradient(180deg, #dc2626 0%, #f87171 100%)' : 'linear-gradient(180deg, #f44336 0%, #ef5350 100%)',
                      borderRadius: '2px'
                    }} />
                    <Typography sx={{
                      color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                      fontWeight: 700,
                      fontSize: 14,
                      letterSpacing: '0.3px'
                    }} variant='h5'>
                      Equipamientos
                    </Typography>
                  </Box>
                  <IconButton
                    sx={{
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      width: 28,
                      height: 28,
                      background: isDarkMode ? 'linear-gradient(135deg, #2d3a52 0%, #3d4a62 100%)' : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        background: isDarkMode ? 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)' : 'linear-gradient(135deg, #0364ff 0%, #4a90e2 100%)',
                        transform: 'rotate(90deg)',
                        '& svg': {
                          color: isDarkMode ? '#e0e0e0' : '#fff'
                        }
                      }
                    }}
                    onClick={()=>onOpenModalEquipamientoAdd()}
                  >
                    <EditIcon sx={{color: isDarkMode ? '#e0e0e0' : '#2c3e50', fontSize: 14}} />
                  </IconButton>
                </Box>
                <Box sx={{p: 1.5}}>
                  {equipamientos?.length > 0 ? (
                    equipamientos.map((itemEquip, index)=>(
                      <Box 
                        key={index}
                        sx={{
                          mt: index > 0 ? 1 : 0,
                          animation: 'fadeInLeft 0.4s ease-out',
                          animationDelay: `${index * 0.1}s`,
                          animationFillMode: 'both',
                          '@keyframes fadeInLeft': {
                            '0%': {
                              opacity: 0,
                              transform: 'translateX(-20px)'
                            },
                            '100%': {
                              opacity: 1,
                              transform: 'translateX(0)'
                            }
                          }
                        }}
                      >
                        <Card sx={{
                          background: isDarkMode ? 'linear-gradient(135deg, #2d3a52 0%, #3d4a62 100%)' : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                          p: 1,
                          borderRadius: '8px',
                          border: isDarkMode ? '1px solid #4a5a72' : '1px solid #dee2e6',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            transform: 'translateX(4px)',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            background: isDarkMode ? 'linear-gradient(135deg, #3a1a1a 0%, #5a2a2a 100%)' : 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)'
                          }
                        }}>
                          <Typography sx={{
                            color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                            fontWeight: 600,
                            fontSize: 11,
                            textAlign: 'center'
                          }}>
                            {itemEquip?.nombreEquipo_eqt}
                          </Typography>
                        </Card>
                      </Box>
                    ))
                  ) : (
                    <Typography sx={{color: isDarkMode ? '#b0bec5' : 'gray', textAlign: 'center', py: 2, fontSize: 12}}>
                      No hay equipamientos registrados
                    </Typography>
                  )}
                </Box>
              </Card>
            </Box>
            <Divider sx={{
              background: isDarkMode ? 'linear-gradient(90deg, transparent, #3d4a62 50%, transparent)' : 'linear-gradient(90deg, transparent, #cbd5e0 50%, transparent)',
              height: '1px',
              border: 'none',
              my: 1
            }} />
            { contratoSoft && contratoSoft?.length > 0 && (
              <Box>
                <Card sx={{
                  background: isDarkMode ? '#2d3a52' : 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
                  borderRadius: '0px',
                  border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e8ef',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                  overflow: 'hidden',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  }
                }}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 2,
                    py: 1.5,
                    background: isDarkMode ? 'linear-gradient(135deg, #3a2a4a 0%, #4a3a5a 100%)' : 'linear-gradient(135deg, #ede7f6 0%, #f3eef8 100%)',
                    borderBottom: isDarkMode ? '1px solid #5a4a6a' : '1px solid #d1c4e9'
                  }}>
                    <Box sx={{
                      width: 4,
                      height: 18,
                      background: isDarkMode ? 'linear-gradient(180deg, #7c3aed 0%, #a78bfa 100%)' : 'linear-gradient(180deg, #673ab7 0%, #9575cd 100%)',
                      borderRadius: '2px'
                    }} />
                    <Typography sx={{
                      color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                      fontWeight: 700,
                      fontSize: 14,
                      letterSpacing: '0.3px'
                    }} variant='h5'>
                      Servicios
                    </Typography>
                  </Box>
                  <Box sx={{p: 1.5}}>
                    {contratoSoft?.map((tr, idx)=>{
                        if(tr && Object?.keys(tr)?.length > 0 ){
                          const serviceKey = Object.keys(tr)[0] || idx;
                          return (
                            <ListContratoSoft
                              key={`contrato-${serviceKey}`}
                              tr={tr}
                              ticket={id}
                              estadoTicket={ticket?.estado_tk}
                              onGuardar={actualizar}
                            />
                          )
                        }
                        return null;
                    })}
                  </Box>
                </Card>
              </Box>
            )}
            { ticket && !ticket?.cerrado_tk && permisos['contactos.verCambioTitular'] &&(
              <>
                { ticket && ticket?.motivo_tk === 26 && ticket?.cierreTicketId_tk !== 9 && (
                  <Box sx={{width: '100%'}}>
                    <Divider sx={{
                      background: isDarkMode ? 'linear-gradient(90deg, transparent, #3d4a62 50%, transparent)' : 'linear-gradient(90deg, transparent, #cbd5e0 50%, transparent)',
                      height: '1px',
                      border: 'none',
                      my: 2
                    }} />
                    <Box sx={{px: 2, py: 1}}>
                      <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        mb: 1.5,
                        pb: 1,
                        borderBottom: isDarkMode ? '2px solid #3d4a62' : '2px solid #e8eef5'
                      }}>
                        <Box sx={{
                          width: 4,
                          height: 18,
                          background: isDarkMode ? 'linear-gradient(180deg, #1e3a8a 0%, #2563eb 100%)' : 'linear-gradient(180deg, #2196f3 0%, #64b5f6 100%)',
                          borderRadius: '2px'
                        }} />
                        <Typography sx={{
                          color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                          fontWeight: 700,
                          fontSize: 14,
                          letterSpacing: '0.3px'
                        }} variant='h5'>
                          Nuevo Contacto
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{flex:1, p: 2}}>
                      {nuevoTitular?.disponible && !ticket?.cerrado_tk ? (
                        <>
                          <Box sx={{display: 'flex',justifyContent: 'center', alignItems: 'center'}}>
                            <ButtonBasic
                              textButton='Crear nuevo contacto'
                              variant='wk'
                              color='nextStep'
                              onClick={()=>onClickCambioTitular()}
                            />
                          </Box>
                        </>
                      ):(  
                        <Card sx={{background: isDarkMode ? '#2d3a52' : '#fff !important',p: 2,boxShadow:4,borderRadius: 3, display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>
                          <TextInfoTicket
                            titulo={!nuevoTitular?.cuentaContratoId_t ? 'Nro Pre-Servicio' : 'Nro Servicio'}
                            descripcion={`#${nuevoTitular?.id_t}`}
                            onClick={()=>navigate(`/pre-servicio/${nuevoTitular?.id_t}/nubicom`)}
                          />
                          <TextInfoTicket
                            titulo='Contacto'
                            descripcion={nuevoTitular?.nombre_t}
                            onClick={()=>{
                              if(nuevoTitular?.cuentaId_t){
                                navigate(`/contactos/${nuevoTitular?.cuentaId_t}/cuenta`)
                              }else{
                                navigate(`/contactos/${nuevoTitular?.contactoId_t}/nubicom`)
                              }
                            }}
                          />
                          { nuevoTitular?.id_t && !nuevoTitular?.confirmaAltaCambioTitular_t && (
                            <>
                              {(!nuevoTitular?.camTitularContrato_t || !nuevoTitular?.camTitularConstancia_t) && (
                                <ButtonBasic
                                  textButton='Adjuntar Contrato y Constancias'
                                  variant='wk'
                                  color='nextStep'
                                  sx={{mb: 1,borderRadius: 2}}
                                  onClick={()=>onOpenModalAdjContConst(nuevoTitular?.id_t)}
                                />
                              )}
                              <ButtonBasic
                                textButton='Cancelar cambio de titular'
                                variant='wk'
                                color='error'
                                onClick={()=>onCancelarCambioTitular(nuevoTitular?.id_t)}
                              />
                            </>
                          )}
                        </Card>
                      )}
                    </Box>
                  </Box>
                )}
              </>
            )}
            { ticket && ticket?.tratos?.length > 0 && (
              <>
                <Divider sx={{
                  background: isDarkMode ? 'linear-gradient(90deg, transparent, #3d4a62 50%, transparent)' : 'linear-gradient(90deg, transparent, #cbd5e0 50%, transparent)',
                  height: '1px',
                  border: 'none',
                  my: 2
                }} />
                <Box sx={{px: 2, py: 1}}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    mb: 1.5,
                    pb: 1,
                    borderBottom: isDarkMode ? '2px solid #3d4a62' : '2px solid #e8eef5'
                  }}>
                    <Box sx={{
                      width: 4,
                      height: 18,
                      background: isDarkMode ? 'linear-gradient(180deg, #4338ca 0%, #6366f1 100%)' : 'linear-gradient(180deg, #3f51b5 0%, #7986cb 100%)',
                      borderRadius: '2px'
                    }} />
                    <Typography sx={{
                      color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                      fontWeight: 700,
                      fontSize: 14,
                      letterSpacing: '0.3px'
                    }} variant='h5'>
                      Pre-Servicios
                    </Typography>
                  </Box>
                </Box>
                {ticket.tratos.map((tr)=>(
                    <ListInfoCam
                      tr={tr}
                      onModal={onOpenModalConfirmInstalacion}
                      onModalPrefa={onOpenModalConfirmPrefactibilidad}
                      onModalItems={onOpenModalConfirmItemsPrefa}
                      ticket={ticket}
                    />
                  ))}
                <Divider sx={{
                  background: 'linear-gradient(90deg, transparent, #cbd5e0 50%, transparent)',
                  height: '1px',
                  border: 'none',
                  my: 1
                }} />
              </>
            )}
            <Box>
              <Card sx={{
                background: isDarkMode ? '#2d3a52' : 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
                borderRadius: '0px',
                border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e8ef',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                }
              }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  px: 2,
                  py: 1.5,
                  cursor: 'pointer',
                  background: isDarkMode ? 'linear-gradient(135deg, #1a3a3a 0%, #2a4a4a 100%)' : 'linear-gradient(135deg, #e0f2f1 0%, #f0f8f7 100%)',
                  borderBottom: openTareas ? (isDarkMode ? '1px solid #3d5a5a' : '1px solid #b2dfdb') : 'none'
                }} onClick={() => setOpenTareas(v => !v)}>
                  <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                    <Box sx={{
                      width: 4,
                      height: 18,
                      background: isDarkMode ? 'linear-gradient(180deg, #0d9488 0%, #14b8a6 100%)' : 'linear-gradient(180deg, #009688 0%, #4db6ac 100%)',
                      borderRadius: '2px'
                    }} />
                    <Typography sx={{
                      color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                      fontWeight: 700,
                      fontSize: 14,
                      letterSpacing: '0.3px'
                    }} variant='h5'>
                      Tareas del Calendario
                    </Typography>
                  </Box>
                  <IconButton size='small' sx={{color: isDarkMode ? '#b0bec5' : '#607d8b', p: 0.3}} onClick={(e) => { e.stopPropagation(); setOpenTareas(v => !v); }}>
                    {openTareas ? <KeyboardArrowUpIcon fontSize='small' /> : <KeyboardArrowDownIcon fontSize='small' />}
                  </IconButton>
                </Box>
                <Collapse in={openTareas}>
                <Box sx={{p: 1.5}}>
                  {tareasCerradas && !ticket?.cerrado_tk && ([1,2,3,6]?.includes(ticket?.motivotk?.tipoTareaId_mt)) && permisos['calendar.createdTarea'] && (linkContratoSoft?.tipo !== 'NCORP' && linkContratoSoft?.tipo !== 'Corporativo' && trato?.categoria_t !== 'COR' ) && (
                    <Box sx={{display:'flex', justifyContent:'center', mb: 1}}>
                      <ButtonBasic
                        variant="text"
                        textButton='Crear tarea'
                        sx={{color: isDarkMode ? '#90caf9' : '#0364ff',fontSize:14}}
                        onClick={()=>onOpenModalCrearTarea()}
                      />
                    </Box>
                  )}
                  {tareas && Array.isArray(tareas) && tareas?.length > 0 ?(
                      tareas?.map((tar)=>( <ListTarea tarea={tar} traerTareas={traerTareas} /> ))
                  ):(
                    <Typography sx={{color: isDarkMode ? '#b0bec5' : 'gray',textAlign: 'center',py: 2, fontSize: 12}}>No se registraron tareas</Typography>
                  )}
                </Box>
                </Collapse>
              </Card>

              {/* Ordenes de Trabajo */}
              <Card sx={{
                mt: 2,
                background: isDarkMode ? '#243040' : '#fff',
                borderRadius: '10px',
                boxShadow: isDarkMode ? '0 2px 12px rgba(0,0,0,0.25)' : '0 2px 12px rgba(0,0,0,0.06)',
                border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e8ef',
                overflow: 'hidden'
              }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  px: 2,
                  py: 1.5,
                  cursor: 'pointer',
                  background: isDarkMode ? 'linear-gradient(135deg, #1a2a3a 0%, #2a3a4a 100%)' : 'linear-gradient(135deg, #e8f0fe 0%, #f0f4ff 100%)',
                  borderBottom: openOT ? (isDarkMode ? '1px solid #3d4a62' : '1px solid #c5d0e8') : 'none'
                }} onClick={() => setOpenOT(v => !v)}>
                  <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                    <Box sx={{
                      width: 4,
                      height: 18,
                      background: isDarkMode ? 'linear-gradient(180deg, #3b82f6 0%, #60a5fa 100%)' : 'linear-gradient(180deg, #1565c0 0%, #1976d2 100%)',
                      borderRadius: '2px'
                    }} />
                    <Typography sx={{
                      color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                      fontWeight: 700,
                      fontSize: 14,
                      letterSpacing: '0.3px'
                    }} variant='h5'>
                      Ordenes de Trabajo
                    </Typography>
                  </Box>
                  <IconButton size='small' sx={{color: isDarkMode ? '#b0bec5' : '#607d8b', p: 0.3}} onClick={(e) => { e.stopPropagation(); setOpenOT(v => !v); }}>
                    {openOT ? <KeyboardArrowUpIcon fontSize='small' /> : <KeyboardArrowDownIcon fontSize='small' />}
                  </IconButton>
                </Box>
                <Collapse in={openOT}>
                <Box sx={{p: 1.5}}>
                  {otServicio?.ots && otServicio.ots.length > 0 ? (
                    otServicio.ots.map((ot) => (
                      <Card key={ot.id_ot} sx={{
                        mb: 1.5,
                        background: isDarkMode ? '#1e2d3d' : '#f8faff',
                        border: isDarkMode ? '1px solid #3d4a62' : '1px solid #dce6f5',
                        borderRadius: '8px',
                        overflow: 'hidden'
                      }}>
                        {/* Header OT */}
                        <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          px: 1.5,
                          py: 1,
                          cursor: 'pointer',
                          background: isDarkMode ? '#162030' : '#e8f0fe',
                          borderBottom: openOTCards[ot.id_ot] !== false ? (isDarkMode ? '1px solid #2d3a4a' : '1px solid #c5d0e8') : 'none'
                        }} onClick={() => setOpenOTCards(prev => ({ ...prev, [ot.id_ot]: prev[ot.id_ot] === false ? true : false }))}>
                          <Typography sx={{ fontWeight: 700, fontSize: 13, color: isDarkMode ? '#90caf9' : '#1565c0' }}>
                            OT #{ot.nroOTText_ot}
                          </Typography>
                          <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                            <Box sx={{
                              px: 1.5,
                              py: 0.3,
                              borderRadius: '12px',
                              background: ot.estado_ot === 'Cerrada'
                                ? (isDarkMode ? '#1b3a2d' : '#e8f5e9')
                                : (isDarkMode ? '#3a2020' : '#fff3e0'),
                              border: ot.estado_ot === 'Cerrada'
                                ? (isDarkMode ? '1px solid #2e7d32' : '1px solid #a5d6a7')
                                : (isDarkMode ? '1px solid #bf360c' : '1px solid #ffcc80')
                            }}>
                              <Typography sx={{
                                fontSize: 11,
                                fontWeight: 700,
                                color: ot.estado_ot === 'Cerrada'
                                  ? (isDarkMode ? '#81c784' : '#2e7d32')
                                  : (isDarkMode ? '#ffb74d' : '#e65100')
                              }}>
                                {ot.estado_ot}
                              </Typography>
                            </Box>
                            <IconButton size='small' sx={{color: isDarkMode ? '#b0bec5' : '#607d8b', p: 0.3}} onClick={(e) => { e.stopPropagation(); setOpenOTCards(prev => ({ ...prev, [ot.id_ot]: prev[ot.id_ot] === false ? true : false })); }}>
                              {openOTCards[ot.id_ot] === false ? <KeyboardArrowDownIcon fontSize='small' /> : <KeyboardArrowUpIcon fontSize='small' />}
                            </IconButton>
                          </Box>
                        </Box>

                        {/* Body OT */}
                        <Collapse in={openOTCards[ot.id_ot] !== false}>
                        <Box sx={{p: 1.5, display: 'flex', flexDirection: 'column', gap: 0.6}}>
                          <Box sx={{display: 'flex', gap: 0.5}}>
                            <Typography sx={{fontSize: 11, fontWeight: 600, color: isDarkMode ? '#90caf9' : '#1565c0', minWidth: 90}}>Tipo:</Typography>
                            <Typography sx={{fontSize: 11, color: isDarkMode ? '#cfd8dc' : '#37474f'}}>{ot.tipoOT}</Typography>
                          </Box>
                          <Box sx={{display: 'flex', gap: 0.5}}>
                            <Typography sx={{fontSize: 11, fontWeight: 600, color: isDarkMode ? '#90caf9' : '#1565c0', minWidth: 90}}>Clase:</Typography>
                            <Typography sx={{fontSize: 11, color: isDarkMode ? '#cfd8dc' : '#37474f'}}>{ot.claseOT}</Typography>
                          </Box>
                          <Box sx={{display: 'flex', gap: 0.5}}>
                            <Typography sx={{fontSize: 11, fontWeight: 600, color: isDarkMode ? '#90caf9' : '#1565c0', minWidth: 90}}>Segmento:</Typography>
                            <Typography sx={{fontSize: 11, color: isDarkMode ? '#cfd8dc' : '#37474f'}}>{ot.segmentoOT}</Typography>
                          </Box>
                          <Box sx={{display: 'flex', gap: 0.5}}>
                            <Typography sx={{fontSize: 11, fontWeight: 600, color: isDarkMode ? '#90caf9' : '#1565c0', minWidth: 90}}>Cuadrilla:</Typography>
                            <Typography sx={{fontSize: 11, color: isDarkMode ? '#cfd8dc' : '#37474f'}}>{ot.asignadoCuadrilla}</Typography>
                          </Box>
                          {ot.strTecnicos && (
                            <Box sx={{display: 'flex', gap: 0.5}}>
                              <Typography sx={{fontSize: 11, fontWeight: 600, color: isDarkMode ? '#90caf9' : '#1565c0', minWidth: 90}}>Técnicos:</Typography>
                              <Typography sx={{fontSize: 11, color: isDarkMode ? '#cfd8dc' : '#37474f'}}>{ot.strTecnicos}</Typography>
                            </Box>
                          )}
                          <Box sx={{display: 'flex', gap: 0.5}}>
                            <Typography sx={{fontSize: 11, fontWeight: 600, color: isDarkMode ? '#90caf9' : '#1565c0', minWidth: 90}}>Programada:</Typography>
                            <Typography sx={{fontSize: 11, color: isDarkMode ? '#cfd8dc' : '#37474f'}}>{ot.fechaProgramada}</Typography>
                          </Box>
                          <Box sx={{display: 'flex', gap: 0.5}}>
                            <Typography sx={{fontSize: 11, fontWeight: 600, color: isDarkMode ? '#90caf9' : '#1565c0', minWidth: 90}}>Dirección:</Typography>
                            <Typography sx={{fontSize: 11, color: isDarkMode ? '#cfd8dc' : '#37474f'}}>{ot.direccion_ot}</Typography>
                          </Box>
                          {ot.cierreOT && (
                            <Box sx={{display: 'flex', gap: 0.5}}>
                              <Typography sx={{fontSize: 11, fontWeight: 600, color: isDarkMode ? '#90caf9' : '#1565c0', minWidth: 90}}>Cierre:</Typography>
                              <Typography sx={{fontSize: 11, color: isDarkMode ? '#cfd8dc' : '#37474f'}}>{ot.cierreOT}</Typography>
                            </Box>
                          )}
                          {ot.observacionesCierre_ot && ot.observacionesCierre_ot !== '-' && (
                            <Box sx={{display: 'flex', gap: 0.5}}>
                              <Typography sx={{fontSize: 11, fontWeight: 600, color: isDarkMode ? '#90caf9' : '#1565c0', minWidth: 90}}>Observación:</Typography>
                              <Typography sx={{fontSize: 11, color: isDarkMode ? '#cfd8dc' : '#37474f'}}>{ot.observacionesCierre_ot}</Typography>
                            </Box>
                          )}
                          <Box sx={{display: 'flex', gap: 0.5}}>
                            <Typography sx={{fontSize: 11, fontWeight: 600, color: isDarkMode ? '#90caf9' : '#1565c0', minWidth: 90}}>Creado por:</Typography>
                            <Typography sx={{fontSize: 11, color: isDarkMode ? '#cfd8dc' : '#37474f'}}>{ot.creadoPor} — {ot.creadoDate}</Typography>
                          </Box>
                          <Box sx={{display: 'flex', justifyContent: 'center', mt: 0.5}}>
                            <Box
                              component='a'
                              href={`https://ztask.45.224.140.25.nip.io/panel/detalle-ot/${ot.nroOTText_ot}`}
                              target='_blank'
                              rel='noopener noreferrer'
                              sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 0.5,
                                px: 1.5,
                                py: 0.5,
                                borderRadius: '6px',
                                fontSize: 11,
                                fontWeight: 600,
                                textDecoration: 'none',
                                color: isDarkMode ? '#90caf9' : '#1565c0',
                                background: isDarkMode ? 'linear-gradient(135deg, #1e2d3d 0%, #2a3a50 100%)' : 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                                border: isDarkMode ? '1px solid #3d5a7a' : '1px solid #90caf9',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  background: isDarkMode ? 'linear-gradient(135deg, #1565c0 0%, #1976d2 100%)' : 'linear-gradient(135deg, #1565c0 0%, #1976d2 100%)',
                                  color: '#fff',
                                  border: '1px solid transparent'
                                }
                              }}
                            >
                              Ver OT en ZTask
                            </Box>
                          </Box>
                        </Box>
                        </Collapse>
                      </Card>
                    ))
                  ) : (
                    <Typography sx={{color: isDarkMode ? '#b0bec5' : 'gray', textAlign: 'center', py: 2, fontSize: 12}}>
                      No se registraron órdenes de trabajo
                    </Typography>
                  )}
                </Box>
                </Collapse>
              </Card>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} md={8.9} ml={1.5}>
          <Card sx={{
            background: isDarkMode ? '#2d3a52' : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
            borderRadius: '12px',
            boxShadow: isDarkMode ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.08)',
            border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e8ef',
            overflow: 'hidden'
          }}>
            {/* Header con información del autor */}
            <Box sx={{
              background: isDarkMode ? '#1F2A40' : '#fff',
              borderBottom: isDarkMode ? '2px solid #3d4a62' : '2px solid #e3e8ef',
              p: 2
            }}>
              <Grid container>
                <Grid item xs={10} md={9} display='flex' alignItems='center'>
                  <Avatar 
                    src={ticket?.autor?.foto_p} 
                    sx={{
                      width: 40, 
                      height: 40,
                      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                      border: isDarkMode ? '2px solid #3d4a62' : '2px solid #fff'
                    }} 
                  />
                  <Box sx={{ml: 2}}>
                    <Typography sx={{
                      color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                      fontWeight: 600,
                      fontSize: 15
                    }} variant='h5'>
                      {ticket?.autor?.nombre_p}
                    </Typography>
                    <Typography sx={{
                      color: isDarkMode ? '#b0bec5' : '#8993a4',
                      fontSize: 12
                    }} variant='body2'>
                      Autor del ticket
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={2} md={3} display='flex' alignItems='center' justifyContent='center'>
                  <Box sx={{
                    background: isDarkMode ? 'linear-gradient(135deg, #1e3a5c 0%, #2a4a6a 100%)' : 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                    px: 2,
                    py: 1,
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.08)'
                  }}>
                    <Typography sx={{
                      color: isDarkMode ? '#90caf9' : '#1565c0',
                      fontWeight: 600,
                      fontSize: 12,
                      textAlign: 'center'
                    }}>
                      {ticket && (
                        `${FechaFunction.format(new Date(ticket?.createdAt),'dd/MM/yyyy HH:mm:ss')}`
                      )}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>

            {/* Sección de Descripción */}
            <Box sx={{background: isDarkMode ? '#1F2A40' : '#fff', p: 3}}>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}>
                <Typography sx={{
                  color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                  fontWeight: 'bold',
                  fontSize: 15,
                  letterSpacing: '0.3px'
                }} variant='h5'>
                  Descripción
                </Typography>
              </Box>
                { ticket && (
                  <Box sx={{background: isDarkMode ? '#e6f0ff' : '#fff', borderRadius: 2}}>
                    <InputReadQuill
                        id="cuerpo_tk"
                        template={ticket?.cuerpo_tk}
                    />
                  </Box>
                )}
            </Box>

            {/* Sección de Adjuntos */}
            <AttachedFileCard 
              attachments={ticket?.imgtk} 
              baseUrl={urlNubi} 
              token={token} 
            />
            {ticket && permisos['ticketNubi.cerrar'] && (!ticket?.cerrado_tk) && (ticket?.prioridad_tk !== 'A DEFINIR') &&(
              <Box sx={{display: 'flex', justifyContent: 'end',pr:2}}>
                  <ButtonBasic
                    textButton='Cerrar ticket'
                    variant='wk'
                    color='downloadHome'
                    sx={{height: 25}}
                    onClick={()=>cerrarTicket()}
                  />
              </Box>
            )}
            { (ticket
              && (!ticket?.reopeningDate_tk || permisos['reapertura_sin_limite_ticket'])
              && permisos['ticketNubi.reapertura']
              && (!ticket.isOpenAgain_tk)
              && (ticket.estado_tk === "CERRADO")
              ) && (
                <Box sx={{display: 'flex', justifyContent: 'end',pr:2}}>
                    <ButtonBasic
                      textButton='Reapertura del ticket'
                      variant='wk'
                      color='nextStep'
                      onClick={()=>onOpenReapertura()}
                    />
                </Box>
            )}
            <Divider sx={{background: isDarkMode ? '#3d4a62 !important' : 'gray !important',pl:-2,marginTop:4}} />
            <Box sx={{background: isDarkMode ? '#1a2332' : '#fafbfb',p:2}}>
              <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold',marginTop:2}} variant='h5'>Comentarios</Typography>
              {ticket && ticket.comentarios.length > 0 ? (
                ticket.comentarios?.map((tk)=>(
                  <ComentarioTicketCard item={tk} key={tk.id_com} user={user} onGuardar={actualizar} />
                ))
              ):(
                <Typography sx={{color: isDarkMode ? '#b0bec5' : '#15294b',textAlign: 'center',marginTop:2,marginBottom:2}} variant='h5'>Aún no hay comentarios</Typography>
              )}
            </Box>
            { ticket && !ticket?.cerrado_tk &&(
              <Divider sx={{background: isDarkMode ? '#3d4a62 !important' : 'gray !important',pl:-2,marginTop:1}} />
            )}
            <Box sx={{background: isDarkMode ? '#1F2A40' : '#fff',p:2}}>
                { ticket && !ticket?.cerrado_tk &&(
                  <Box mb={2}>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold',marginBottom:2}} variant='h5'>Dejar un comentario</Typography>
                      <InputEditQuill
                          id="comentario12dsas"
                          template={comentario}
                          etiqueta
                          onChangeText={(html)=>{
                              setComentario(html)
                          }}
                      />
                      <Grid container mt={1}>
                          { filesCompress?.length > 0 &&(
                            filesCompress.map((fil)=>(
                              <Grid item xs={12} sm={5.8} md={3.8} lg={3.8} ml={1} mt={{xs:1,lg:0}}>
                                <CardUploadFile item={fil} key={fil?.id} onDeleted={(e)=>onDeletedFile(e)} />
                              </Grid>
                            ))
                          )}
                      </Grid>
                      <Box sx={{display: 'flex', justifyContent: 'flex-start', mt: 2, mb: 1}}>
                        <ButtonBasic
                          onClick={handlePasteFromClipboard}
                          startIcon={<ContentPasteIcon />}
                          variant='wk'
                          color='nextStep'
                          textButton='Pegar imagen del portapapeles'
                          sx={{height: 35}}
                        />
                      </Box>
                      <Box sx={{border: 2, borderColor: isDarkMode ? '#3d4a62' : '#a6aebb',borderStyle: 'dashed',mt:1,mb:1,borderRadius: 3,'&:hover':{border: 2,borderColor: isDarkMode ? '#5a6a82' : '#505f79',borderStyle: 'dashed'}}}>
                        <InputDropZoneComment
                          id="otImg"
                          backgroundImage="/img/svideo.png"
                          onChange={(e)=>setFiles((old)=>[...old,...e])}
                          setFoto={setFiles}
                          accept={acceptInputFile}
                        />
                      </Box>
                      <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <ButtonBasic
                            onClick={onSubmit}
                            isLoading={isLoading}
                            sx={{width: 300,marginTop:1}}
                            variant='wk'
                            color='nextStep'
                            textButton='Realizar Comentario'
                        />
                      </Box>
                  </Box>
                )}
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.currentUser
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(TicketGetByIdNubiScreen);